import React, { useEffect, useRef } from 'react';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';
import { userService } from '../services';

interface ThemeSyncProviderProps {
  children: React.ReactNode;
}

export const ThemeSyncProvider: React.FC<ThemeSyncProviderProps> = ({ children }) => {
  const { user, refreshUser } = useAuth();
  const { mode, setThemeMode } = useTheme();
  const hasInitialized = useRef(false);
  const lastSavedMode = useRef<string | null>(null);

  // Initialize theme from user preferences on first load only.
  // We deliberately exclude `setThemeMode` from deps because it is now
  // stable (useCallback in ThemeContext), and we only want this effect to
  // re-run when the user object changes — not on every theme re-render.
  // The hasInitialized guard ensures we never overwrite a user's in-session
  // toggle with a stale server preference.
  useEffect(() => {
    if (!hasInitialized.current && user?.preferences?.theme) {
      hasInitialized.current = true;
      lastSavedMode.current = user.preferences.theme;
      setThemeMode(user.preferences.theme);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  // Save theme to server when it changes locally
  // TODO: Re-enable when user preferences API is implemented
  /*
  useEffect(() => {
    // Skip if no user, not initialized yet, or mode hasn't changed
    if (!user || !hasInitialized.current || mode === lastSavedMode.current) {
      return;
    }

    // Skip 'auto' mode as it's not a final choice
    if (mode === 'auto') {
      return;
    }

    const saveThemePreference = async () => {
      try {
        await userService.updateProfile({
          preferences: {
            ...user.preferences,
            theme: mode
          }
        });
        lastSavedMode.current = mode;
        // Refresh user to get updated data
        await refreshUser();
      } catch (error) {
        console.error('Failed to save theme preference:', error);
        // Revert to last saved mode on error
        if (lastSavedMode.current) {
          setThemeMode(lastSavedMode.current as any);
        }
      }
    };

    // Debounce the save operation
    const timeoutId = setTimeout(saveThemePreference, 500);
    return () => clearTimeout(timeoutId);
  }, [mode, user, refreshUser, setThemeMode]);
  */

  return <>{children}</>;
};